import style from './index.module.styl'
import Utils from '@/common/js/utils'
import elUtils from '@/common/js/el-util'
const voiceImg = 'http://shdxcx.oss-cn-shenzhen.aliyuncs.com/20181030/1626fc406ab42a6c70e3b9d40427854c.png'
const DELAY_TIME = 300

export default {
  name: 'dj-audio',
  props: {
    audioSrc: {
      type: String
    },
    music: {
      type: Object,
      default: () => ({
        src: voiceImg,
        h: 34,
        w: 34,
        x: 333.5,
        y: 10
      })
    }
  },
  data() {
    return {
      isPlaying: false,
      isHide: false
    }
  },
  methods: {
    handleClickBtn: Utils.throttle(function() {
      this.isPlaying = !this.isPlaying
      window.howlAudio && window.howlAudio[this.isPlaying ? 'play' : 'pause']()
    }, DELAY_TIME)
  },
  render() {
    const posStyle = elUtils.getPositionStyle(this.music)
    posStyle.zIndex = this.isHide ? `-10` : `340`
    return (
      <img style={posStyle} onClick={this.handleClickBtn} class={{ [style['voice']]: true, [style['playing']]: this.isPlaying}} src={this.music.src} alt="voice-img"/>
    )
  }
}